<app-layout type="white" size="100%">
  <app-breadcrumb [breadcrumbItems]="[
    { label: ('breadcrumb.login' | translate), link: '/' },
    { label: ('breadcrumb.register' | translate) }
  ]"></app-breadcrumb>

  <div class="register-content">
    <app-title title="register.emailSent.title" />

    <app-stepper
      [steps]="['register.stepper.step1', 'register.stepper.step2', 'register.stepper.step3']"
      [currentStep]="1"
    />

    <div class="success-message">
      <div class="success-icon">
        <app-icon-envelope />
      </div>
      <div class="success-text">
        <p [innerHTML]="'register.emailSent.message' | translate: { email: email }"></p>
        <p class="sub-text">{{ 'register.emailSent.subText' | translate }}</p>
      </div>
    </div>
  </div>
</app-layout>
